import {Pipe, PipeTransform} from "@angular/core";
import {DecimalPipe} from "@angular/common";

@Pipe({name: 'filesize'})
export class NbinputFilesizePipe implements PipeTransform {
  transform(value, args:string[]) : any {
    if (value > 1073741824) {
      return this.number.transform(value/1073741824,'1.0-2') + 'G';
    } else if (value > 1048576) {
      return this.number.transform(value/1048576,'1.0-2') + 'M';
    } else if (value > 1024) {
      return this.number.transform(value/1024,'1.0-2') + 'K';
    }
    return this.number.transform(value,'1.0-2') + 'B';
  }
  constructor(private number: DecimalPipe){}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-filesize.pipe.ts